import React, { Component } from "react";
import logger from "../../utils/logger";
import * as styles from "./styles.module.scss";
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    componentDidCatch(error) {
        this.setState({ hasError: true });
        console.log(error);
        logger.error(error);
    }
    render() {
        if (this.state.hasError) {
            return (React.createElement("div", { className: styles.root },
                React.createElement("h2", { className: styles.title }, "Sorry, something went wrong"),
                React.createElement("p", { className: styles.subtitle },
                    "You can try refreshing the page, or you can go to the",
                    " ",
                    React.createElement("a", { className: styles.link, href: "/" }, "home page"),
                    ".")));
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
